import { useState } from "react";
import { AUTH_REQUIRED } from "../lib/api";
import { AlertTriangle, RefreshCw, ScanSearch, SlidersHorizontal } from "lucide-react";

interface StatusLayerProps {
  status: "loading" | "ready" | "error";
  error: string | null;
  empty: boolean;
  onRetry: () => void;
  onOpenFilters: () => void;
}
export function StatusLayer({ status, error, empty, onRetry, onOpenFilters }: StatusLayerProps) {
  const [token, setToken] = useState("");
  if (status === "error" && error === AUTH_REQUIRED) {
    return <form className="status-layer auth-state" onSubmit={event => {
      event.preventDefault();
      if (!token.trim()) return;
      sessionStorage.setItem("lobster-operator-token", token.trim());
      onRetry();
    }}>
      <strong>Connect to your private radar</strong>
      <span>Enter your production operator token. Reconnecting without it cannot unlock your pipeline.</span>
      <label htmlFor="radar-access-token">Operator token</label>
      <input id="radar-access-token" type="password" autoComplete="current-password" required value={token} onChange={event => setToken(event.target.value)} />
      {sessionStorage.getItem("lobster-operator-token") && <span role="alert">The saved token was not accepted. Enter the production token to try again.</span>}
      <span>The local-radar-only development token does not work on the live site.</span>
      <button type="submit" disabled={!token.trim()}>Connect securely</button>
    </form>;
  }
  if (status === "loading") {
    return (
      <div className="status-layer loading-state" aria-live="polite">
        <span className="scan-orbit"><ScanSearch size={19} /></span>
        <strong>Scanning active field</strong>
        <span>Receiving qualified signals from Job Lobster</span>
      </div>
    );
  }
  if (status === "error") {
    return (
      <div className="status-layer error-state" role="alert">
        <AlertTriangle size={21} />
        <strong>Signal link interrupted</strong>
        <span>{error}</span>
        <button type="button" onClick={onRetry}><RefreshCw size={14} /> Reconnect</button>
      </div>
    );
  }
  if (empty) {
    return (
      <div className="status-layer empty-state">
        <strong>No signals in this field</strong>
        <span>Widen the age, salary, or region filters.</span>
        <button type="button" onClick={onOpenFilters}><SlidersHorizontal size={14} /> Adjust filters</button>
      </div>
    );
  }
  return null;
}
